import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import ChatApp from "../../images/Chat App.png";
import pepperFry from "../../images/pepperfryApp.png";
import todoApp from "../../images/todoAppDesign.png";
import { HashLink as Link } from "react-router-hash-link";

export default function Logo() {
  return (
    <AnimatePresence>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <Link to="/ChatApp#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={ChatApp}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />
            <h6 className="text-center proj--name">
              Chat App Design In Adobe XD
            </h6>
          </Link>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <Link to="/pepperFry#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={pepperFry}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />
            <h6 className="text-center proj--name">
              Pepperfry App Design In Adobe XD
            </h6>
          </Link>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <Link to="/todoApp#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={todoApp}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />
            <h6 className="text-center proj--name">
              Todo App Design In Adobe XD
            </h6>
          </Link>
        </div>
      </div>
    </AnimatePresence>
  );
}
